import { render, staticRenderFns } from "./PaymentsInfo.vue?vue&type=template&id=659c1506&"
import script from "./PaymentsInfo.vue?vue&type=script&lang=ts&"
export * from "./PaymentsInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports